module.exports = __webpack_public_path__ + "c379922c7a1e1baf3dd95d4fc61899a8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PFDinTextCompPro-Regular.ttf
// module id = 46
// module chunks = 0